<section class="section bg-light">
  <div class="container bring-to-front pb-0">
    <div class="section-heading text-center w-75 mx-auto">
      <h2>Why Dashcore template?</h2>
      <p class="lead text-secondary">
        When you're looking for a template you want it to stand-out. Dashcore
        comes with hundreds of customizable features addressed to developers and
        designers.
      </p>
    </div>

    <div class="shadow bg-contrast p-5 rounded">
      <ngb-tabset
        type="tabs tabs-clean slide d-inline-flex mb-4"
        [destroyOnHide]="false"
      >
        <ngb-tab>
          <ng-template ngbTabTitle
            ><span class="bold text-uppercase">Developers</span></ng-template
          >
          <ng-template ngbTabContent>
            <div class="row gap-y">
              <div class="col-lg-6">
                <h2 class="bold mb-4">
                  Engaging developers with organized code
                </h2>
                <p class="lead text-secondary">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Culpa cumque deleniti facere ipsa laborum saepe, tenetur
                  ullam? Consequatur, deserunt eaque facilis hic, illo
                  laboriosam minima quae quia temporibus totam vel.
                </p>
              </div>
              <div class="col-lg-6">
                <figure class="px-2">
                  <img
                    src="assets/img/screens/developer.png"
                    class="img-responsive shadow rounded"
                    alt="..."
                  />
                </figure>
              </div>
            </div>
          </ng-template>
        </ngb-tab>

        <ngb-tab>
          <ng-template ngbTabTitle
            ><span class="bold text-uppercase">Designers</span></ng-template
          >
          <ng-template ngbTabContent>
            <div class="row gap-y">
              <div class="col-lg-6">
                <h2 class="bold mb-4">
                  Engaging designers with tons of design elements
                </h2>
                <p class="lead text-secondary">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Culpa cumque deleniti facere ipsa laborum saepe, tenetur
                  ullam? Consequatur, deserunt eaque facilis hic, illo
                  laboriosam minima quae quia temporibus totam vel.
                </p>
              </div>
              <div class="col-lg-6">
                <figure class="px-2">
                  <img
                    src="assets/img/screens/designer.png"
                    class="img-responsive shadow rounded"
                    alt="..."
                  />
                </figure>
              </div>
            </div>
          </ng-template>
        </ngb-tab>
      </ngb-tabset>
    </div>
  </div>
</section>
